import { render, staticRenderFns } from "./StockItemsEdit.vue?vue&type=template&id=3783cf8c&scoped=true&"
import script from "./StockItemsEdit.vue?vue&type=script&lang=js&"
export * from "./StockItemsEdit.vue?vue&type=script&lang=js&"
import style0 from "./StockItemsEdit.vue?vue&type=style&index=0&id=3783cf8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3783cf8c",
  null
  
)

export default component.exports